export default "__VITE_ASSET__DIqC4UM4__"